import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private _refreshUser = new Subject<void>();

  /**
   * Constructor
   *
   * @param {HttpClient} _httpClient
   */
  constructor(private _httpClient: HttpClient) { }

  get refreshUser() {
    return this._refreshUser;
  }

  getAll() {
    return this._httpClient.get(`${environment.apiUrl}/liste/user`);
  }

  getUser(id) {
    return this._httpClient.get(`${environment.apiUrl}/user/${id}`);
  }

  update(id, email, cin, role) {
    return this._httpClient
      .put(`${environment.apiUrl}/update/user/${id}`, { email, cin, role })
      .pipe(
        tap(() => {
          this._refreshUser.next()
        })
      );
  }
}
